import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import env from '../enviorments'
import header from '../header'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: null,
        user: null,
    },
    getters: {

    },
    mutations: {
        mutateUser(state, user) {
            state.user = user
        },
        mutateToken(state, token) {
            state.token = token
        },
    },
    actions: {
        //Auth
        async userLogin({commit}, user) {
            const result = (await axios.post(env.apiUrl + 'auth/login', {...user})).data
            if (result.success == false) return {"success": false, "data": [], "message": result.message, "error": []}
            window.localStorage.setItem('token', JSON.stringify(result.data.token))
            window.localStorage.setItem('user', JSON.stringify(result.data.admin))
            commit('mutateToken', result.data.token)
            commit('mutateUser', result.data.admin)

            return {"success": true, "data": result.data.admin, "message": "login is success.", "error": []}
        },
        //Dashboard
        async dashboardAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'dashboard', {headers: header.getToken()})).data
            if (result.status == false) return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async getExchangeRate({commit}) {
            const result = (await axios.get('https://data-provider.getmmp.link/v1/currencies/latest-rates?isVisible=true', {
                headers: {
                    'x-api-key': '4f0b16e7b657302dfd92f3578cd263ae0c3fbc771d0eeca1b0143c8f26243ee9'
                }
            })).data
            return {"success": true, "data": result, "message": "Success", "error": []}
        },
        async getExchangeRateByDayAction({commit}, option) {
            console.log(option)
            const startDate = option.startDate || ''
            const currencyId = option.currencyId || ''

            const result = (await axios.get('https://data-provider.getmmp.link/v1/currencies/rates?currencyId=' + currencyId + '&startDate=' + startDate + '&numberOfDays=1', {
                headers: {
                    'x-api-key': '4f0b16e7b657302dfd92f3578cd263ae0c3fbc771d0eeca1b0143c8f26243ee9'
                }
            })).data

            if(result){
                return {"success": true, "data": result.rates[0].rates[0].sellRate, "message": "Success", "error": []}
            }
        },
        //Batch Actions
        async batchListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'batch/get-all-batches', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },

        async batchStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'batch/create-batch',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        async batchDetailAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'batch/get-batch-detail', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },

        async batchUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'batch/update-batch',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        async agentDeleteAction({commit}, option) {
            const result = (await axios.post(env.apiUrl + 'agent-delete', {...option}, {headers: header.getToken()})).data
            if (result.status == false) return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },

        async aliasBatchStatusAction({commit}, option) {
             try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'batch/alias-batch-status',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }

        },
        //Fee Actions
        async feeListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'fee/get-all-fees', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async feeStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'fee/create-fee',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async feeUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'fee/update-fee',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        // Payment Actions
        async paymentTermsByFeeAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'payment-term/get-all-payment-terms', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data.data, "message": "Success", "error": []}
        },
        async paymentStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'payment-term/create-payment-term',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async paymentUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'payment-term/update-payment-term',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        // Enrollment Actions
        async getDiscountAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'discount/get-discount', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getBatchCodeAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'batch/get-batch', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getFeeCodeAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'fee/get-fee', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getTermAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'payment-term/get-payment-term', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async enrollmentListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'enrollment/get-all-enrollments', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getEnrollmentCsvExportAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'enrollment/export-enrollments', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async enrollmentTotalAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'enrollment/get-enrollment-total', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": responseData.errors}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async enrollmentStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'enrollment/create-enrollment',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async enrollmentDetailAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'enrollment/get-enrollment-detail', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async enrollmentImportAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'enrollment/import-enrollment',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                // console.error('Error in Store Action:', error.response.data.errors.errors);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error.response.data.errors.errors] };
            }
        },
        async aliasEnrollmentStatusAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'enrollment/alias-enrollment-status',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
         async enrollmentUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'enrollment/update-enrollment',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.log('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error.response.data.errors] };
            }
        },
        async extraReduceAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'enrollment/add-extra-reduce',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        // Receipt Actions can be added here
        async getStudentCodeAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'receipt/get-batch-student', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getEnrollmentAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'receipt/get-enrollment', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getReceiptListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'receipt/get-all-receipts', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getReceiptCsvExportAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'receipt/export-receipts', {headers: header.getToken(), params: option})).data
            // console.log("responseData", responseData)
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getReceiptPdfExportAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'receipt/pdf-receipts', {headers: header.getToken(), params: option})).data
            // console.log("responseData", responseData)
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async receiptTotalAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'receipt/get-receipt-total', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async receiptStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'receipt/create-receipt',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async getBankDetailsAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'receipt/get-bank-details', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        // Student Actions can be added here
        async studentListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'student/get-all-students', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        // Account Actions can be added here
        async accountListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'account/get-all-accounts', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async accountStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'account/create-account',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async accountDetailAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'account/get-account-detail', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async accountUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'account/update-account',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        // Setting Actions can be added here
        async getSettingListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'setting/get-all-settings', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async getSettingDetailAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'setting/get-setting-detail', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async updateSettingAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'setting/update-setting',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async settingToggleAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'setting/toggle-setting',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
         async updatePriceAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'setting/update-price',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        // Discount Actions can be added here
        async discountListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'discount/get-all-discounts', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async discountStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'discount/create-discount',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async discountDetailAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'discount/get-discount-detail', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async discountUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'discount/update-discount',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        async aliasDiscountStatusAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'discount/alias-discount-status',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
        // Payment Method Actions can be added here
        async paymentMethodListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'payment/get-all-payment-methods', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async bankListAction({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'payment/get-all-banks', {headers: header.getToken(), params: option})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        }
    },
    modules: {
    }
})
